import { z } from 'zod'
import { ORTSPUNKT_REGEXP, ORTSPUNKT_MAX_LENGTH } from '../../../../utils'
import { allowedChars } from '../../../../utils/customValidationMessage'

export const Freitext50Schema = z
  .string()
  .max(ORTSPUNKT_MAX_LENGTH)
  .superRefine(allowedChars(ORTSPUNKT_REGEXP))
  .default('')

// Default constants
const DEFAULT_AUFTRAG_33_10 = {
  enabled: true,
  selector: '' as const,
  feld_33_11: '',
  feld_33_12: ''
}

const DEFAULT_BEFEHL_33_FORM = {
  auftrag33_10: DEFAULT_AUFTRAG_33_10
}

// Schema definitions
const Auftrag33_10Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_33_10.enabled),
    selector: z
      .enum(['', 'lzbBk', 'etcsBk'])
      .default(DEFAULT_AUFTRAG_33_10.selector),
    feld_33_11: Freitext50Schema,
    feld_33_12: Freitext50Schema
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_33_10))

// Base schema
const Befehl33FormSchemaBase = z
  .object({
    auftrag33_10: Auftrag33_10Schema
  })
  .default(() => structuredClone(DEFAULT_BEFEHL_33_FORM))

export const Befehl33FormSchema = Befehl33FormSchemaBase

// Validation schema factory
export const createBefehl33FormValidationSchema = () => {
  return Befehl33FormSchemaBase
}

export type Befehl33FormData = z.infer<typeof Befehl33FormSchemaBase>
